import React, { useEffect, useState } from "react";
import Banner from "../components/Banner";
import Advisors from "../components/introduction/Advisors";
import { useLocation } from "react-router-dom";
import { useLoader } from "../context/LoaderContext";
import { fetchAdvisorBanner } from "../api/BannerApi";
import { dynamicFailed } from "../hooks/custom/useToast";
import { IBannerData } from "../exports/interfaces";

const AdvisorsPage = () => {
  const location = useLocation();

  const { setLoading } = useLoader();

  const [advisorBanner, setAdvisorBanner] = useState<IBannerData[]>([]);

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location.pathname, location.hash]);

  useEffect(() => {
      setLoading(true);
      Promise.all([fetchAdvisorBanner()])
        .then(([advisorBannerData]) => {
          setAdvisorBanner(advisorBannerData);
        })
        .catch((error) => {
          dynamicFailed(error.response.data.error.message);
        })
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
    }, [setLoading]);

  return (
    <>
      <Banner title="World-Class Academic Standards & Advisors" bannerImage={advisorBanner?.[0]?.image?.[0]}/>
      <Advisors />
    </>
  );
};

export default AdvisorsPage;
